import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    yesnoList: [],
};
const getters = {
    getYesno: state => state.yesnoList

};

const mutations = {
    YESNO_INFO(state, data) {
        state.yesnoList = data
    }
};

const actions = {
    getYesno({commit}) {
        axiosGet(`crm/yesno/status`).then((response) => {
            commit('YESNO_INFO', response.data)
        }).catch((error) => console.log(error));
    }
};


export default {
    state,
    getters,
    mutations,
    actions
}
